module.exports = __webpack_public_path__ + "themes/mf/img/prize-3.png";


//////////////////
// WEBPACK FOOTER
// ./themes/mf/img/prize-3.png
// module id = 90
// module chunks = 3